import { Heading, type HeadingProps } from '@chakra-ui/react';
import { useHomePageColors } from '@/hooks/useHomePageColors';

export const HomeHeading = ({ children, ...props }: { children: React.ReactNode } & HeadingProps) => {
  const { heading } = useHomePageColors();

  return (
    <Heading
      fontStyle='italic'
      textAlign='center'
      color={heading}
      width={{
        base: '80%',
        md: '70%',
        lg: '70%',
        xl: '100%',
      }}
      fontSize={{
        base: '16px',
        md: '19px',
        lg: '26px',
        xl: '34px',
      }}
      {...props}
    >
      {children}
    </Heading>
  );
};
